import {IS_BROWSER, DOCUMENT} from '../constants/environment'
import {noop, curry} from './function'

const TRANSFORM_PROP = IS_BROWSER
  ? (() => {
    const {style} = DOCUMENT.createElement('div')
    const prefixed = ['msTransform', 'mozTransform', 'webkitTransform'].find(key => key in style)
    return prefixed || 'transform'
  })()
  : 'transform'

/**
 * Throttles a function using window.requestAnimationFrame.
 * @see https://github.com/wuct/raf-throttle
 * @param {function} callback - Callback to run no more than once per animation frame.
 * @returns {function} A throttled callback function suitable for a listener.
 */
export const rafThrottle = (callback = noop) => {
  if (!IS_BROWSER) return {cancel: noop}
  
  let requestId
  const later = args => () => {
    requestId = null
    callback(...args)
  }
  const throttled = (...args) => {
    if (requestId == null) requestId = window.requestAnimationFrame(later(args))
  }
  throttled.cancel = () => window.cancelAnimationFrame(requestId)
  return throttled
}

export const applyTransform = curry((transform, el) => {
  el.style[TRANSFORM_PROP] = transform
})

// IE 11 does not appreciate null when clearing transform styles
export const clearTransform = applyTransform('')



// WEBPACK FOOTER //
// ./src/utils/dom.js